var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "32px",
    viewBox: "0 0 34 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-4.3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A08b",
    transform: "translate(-1100.000000, -79.000000)",
    fill: "#717171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1079.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(21.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.96,0 C20.6933333,0 17.0666667,3.41333333 17.0666667,7.68 L17.0666667,10.6666667 L8.53333333,10.6666667 L4.69333333,10.6666667 L3.2,10.6666667 C1.49333333,10.6666667 0,11.9466667 0,13.6533333 L0,28.8 C0,30.72 1.49333333,32 3.2,32 L22.4,32 C24.1066667,32 25.6,30.72 25.6,29.0133333 L25.6,13.6533333 C25.6,11.9466667 24.1066667,10.6666667 22.4,10.6666667 L20.6933333,10.6666667 L20.6933333,8.10666667 C20.6933333,5.97333333 22.6133333,4.26666667 24.96,4.26666667 C27.3066667,4.26666667 29.2266667,5.97333333 29.2266667,8.10666667 L29.2266667,10.6666667 L33.0666667,10.6666667 L33.0666667,7.68 C33.0666667,3.41333333 29.44,0 24.96,0 Z M12.8,25.6 C10.4533333,25.6 8.53333333,23.68 8.53333333,21.3333333 C8.53333333,18.9866667 10.4533333,17.0666667 12.8,17.0666667 C15.1466667,17.0666667 17.0666667,18.9866667 17.0666667,21.3333333 C17.0666667,23.68 15.1466667,25.6 12.8,25.6 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.7bf5fe49820b60c4b4bb37242009193f.svg";
export { ForwardRef as ReactComponent };